import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer>
      <div className="footer-inner">
        <div className="footer-logo">
          <div className="footer-logo-main">INVESTA<span>ESTATES</span></div>
          <div className="footer-logo-tag">Invest. Live. Prosper.</div>
        </div>

        <ul className="footer-links">
          <li><a href="#about">About</a></li>
          <li><a href="#services">Services</a></li>
          <li><a href="#projects">Projects</a></li>
          <li><a href="#listings">Listings</a></li>
          <li><a href="#contact">Contact</a></li>
        </ul>

        <div className="footer-copy">© {new Date().getFullYear()} INVESTA ESTATES. All rights reserved.</div>
      </div>
    </footer>
  );
};

export default Footer;